import { AppLoading } from '@/components/AppLoading'
import { ErrorDetail } from '@/containers/Errors/ErrorDetail'
import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { useGetError } from '@/hooks/useErrorHandlingSagas'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { Breadcrumbs, type BreadcrumbItems } from 'BrokerTsLib/src/containers/Breadcrumbs'
import { useParams } from 'react-router'

const breadcrumbs: BreadcrumbItems = [
  { to: '/Errors', label: 'Přehled chyb' },
  { label: 'Detail chyby', current: true },
]

export const ErrorDetailPage = () => {
  const { id } = useParams()
  const { data, isLoading, refetch } = useGetError(id)

  return (
    <PageWrapper
      header={
        <>
          <Breadcrumbs items={breadcrumbs} />
          <DashboardHeader title="Detail chyby" />
        </>
      }
      mainProps={{ sx: { pt: { base: 0, md: 8 }, gap: 6, display: 'grid' } }}
    >
      {isLoading && <AppLoading />}
      {data && <ErrorDetail detail={data} reload={refetch} />}
    </PageWrapper>
  )
}
